module.exports = __webpack_public_path__ + "static/img/culture_3.a1d9728.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/culture_3.png
// module id = NYfu
// module chunks = 1